import isMobile from './isMobile';

export const initSectionWhenUserInteracts = (targetElement, callback) => {
  if (!targetElement || !callback) return;

  const setEventListener = (eventName, callbackFn) => {
    document.addEventListener(
      eventName,
      () => {
        callbackFn();
      },
      { once: true },
    );
  };

  setEventListener('touchstart', callback);

  if (isMobile()) return;

  setEventListener('mousemove', callback);
};''
